import React from "react";
import { Sparkles, Layers, Gift, Swords, ShieldCheck, Crown } from "lucide-react";
import { useContentList, useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";

const ICONS = { Sparkles, Layers, Gift, Swords, ShieldCheck, Crown };

const Features = () => {
  const { data: header } = useContentObject("home.features_header", contentFallback("home.features_header"));
  const { items: features } = useContentList("home.features", contentFallback("home.features"));

  return (
    <section className="relative py-28 bg-[#0a0a0d] overflow-hidden">
      <div className="grain" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-px bg-gradient-to-r from-transparent via-[rgba(212,168,67,0.4)] to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center mb-16">
          <div className="ornament">
            <span>{header?.eyebrow || "Por qué Aetheris"}</span>
          </div>
          <h2 className="section-title mt-6">{header?.title || "Características Únicas"}</h2>
          <div className="gold-divider w-40 mt-6" />
          <p className="mt-6 max-w-2xl text-[#b8b3a8]">
            {header?.subtitle || ""}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, idx) => {
            const Icon = ICONS[f.icon] || Sparkles;
            return (
              <article
                key={f.id ?? idx}
                className="group relative overflow-hidden glass rounded-sm p-6 transition-all duration-500 hover:translate-y-[-4px]"
              >
                <div className="relative h-44 -mx-6 -mt-6 mb-6 overflow-hidden">
                  <img
                    src={f.image}
                    alt={f.title}
                    className="absolute inset-0 w-full h-full object-cover saturate-50 group-hover:saturate-100 group-hover:scale-110 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111118] via-[#111118]/40 to-transparent" />
                  <div className="absolute top-4 left-4 w-11 h-11 rounded-sm flex items-center justify-center bg-[#0a0a0d]/80 backdrop-blur border border-[rgba(212,168,67,0.4)] text-[#d4a843]">
                    <Icon className="w-5 h-5" />
                  </div>
                </div>
                <h3 className="font-display font-bold text-xl text-[#f0ebe0] tracking-wide mb-3 group-hover:text-[#f5c542] transition-colors">
                  {f.title}
                </h3>
                <p className="text-sm text-[#b8b3a8] leading-relaxed">{f.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
